import styled, { css } from 'styled-components';

import { IconName } from '@optimus-web/icons';
import { getTransition, OPACITY } from '@optimus-web/local-tokens';
import { Icon } from '../Icon';

interface ExpandIconProps {
    disabled?: boolean;
    expanded?: boolean;
    onClick?: () => void;
}

const ExpandIcon = styled(Icon).attrs(({ expanded }: ExpandIconProps) => ({
    value: IconName.ChevronDown,
    'data-test-icon': expanded ? IconName.ChevronUp : IconName.ChevronDown,
}))<ExpandIconProps>`
    display: inline-block;
    outline: none;
    transform: ${(props) => (props.expanded ? 'rotate(180deg)' : 'none')};
    transition: ${getTransition()};
    vertical-align: middle;
    cursor: pointer;

    ${(props) =>
        props.disabled &&
        css`
            cursor: not-allowed;
            opacity: ${OPACITY.disabled};
        `}
`;

export default ExpandIcon;
